export const GOOGLE_ADS_TEST_IDS = {
  root: 'google-ads-integration',
  loading: 'google-ads-loading',
  statusAlert: 'google-ads-status-alert',
  connectButton: 'google-ads-connect-button',
  connectAnotherButton: 'google-ads-connect-another-button',
  reconnectButton: 'google-ads-reconnect-button',
  disconnectButton: 'google-ads-disconnect-button',
  connectionSelect: 'google-ads-connection-select',
  refreshButton: 'google-ads-refresh-button',
  discardButton: 'google-ads-discard-button',
  accountTable: 'google-ads-account-table',
  selectedCount: 'google-ads-selected-count',
  saveButton: 'google-ads-save-button',
} as const;

